module.exports = {
      id: "61f6d45ee39b4b2b2a957abe02ea894aother.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#61f6d45ee39b4b2b2a957abe02ea894aother.svg",
      toString: function () {
        return this.url;
      }
    }